export enum AlexaRequestTypes {
  ReleaseBackgroundRefRequest = 'alexa/RELEASE_BACKGROUND_REF_REQUEST',
  ReleaseBackgroundRefSuccess = 'alexa/RELEASE_BACKGROUND_REF_SUCCESS',
  ReleaseBackgroundRefFailure = 'alexa/RELEASE_BACKGROUND_REF_FAILURE',
}
